export const MINIMUM_AGE_FOR_REGISTRATION = 18;
export enum VerifiedStatus {
  False = "False",
  Applied = "Applied",
  True = "True",
}
